module.exports = __WEBPACK_EXTERNAL_MODULE_1172__;


//////////////////
// WEBPACK FOOTER
// external "weaCube"
// module id = 1172
// module chunks = 1